import { Injectable } from '@angular/core';
import { HttpParams, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { CreateNewInspectionViewModel, SystemInspectionDetailView, ComponentOnSystemInspectionViewModel, WornPercentageCalculateViewModel, AdditionalObservationListViewModel, InspectionAdditionalObservationListsViewModel, ModelSelectionOptionViewModel, InspectionTypeConfigurationViewModel, InspectionAdditionalObservationImagesVM, AdditonalObsNumaricalLimits, SystemInspectionDetailViewVM, InspectionValidatorRequest, InspectionValidationViewVM } from '../models/create-inspection.model';
import { AddComponentPhotoModel } from '../../interpretation/models/interpretation.model';
import { Tuple, Tuple3 } from '../../../entities';
import { AnswerListVM } from '../../GET_NEW_UI/perform-induction/perform-induction';
import { GenericIdName } from '../../GET_NEW_UI/setup-implement/setup-implement.model';
@Injectable()
export class NewInspectionService {

  constructor(private _http: HttpClient) { }

  public GetUserPreferences(): Observable<string> {
    return this._http.get<string>('api/inspection/GetUserPreferences').pipe(catchError(this.handleError));
  }

  public GetUserDistancePreferences(): Observable<string> {
    return this._http.get<string>('api/inspection/GetUserPreferencesDistance').pipe(catchError(this.handleError));
  }

  getInspection(equipmentId, inspectionId): Observable<CreateNewInspectionViewModel> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('inspectionId', inspectionId.toString())
    };
    return this._http.get<CreateNewInspectionViewModel>('api/Inspection/GetInspectionSP', options).pipe(catchError(this.handleError));
    //return this._http.get<CreateNewInspectionViewModel>('api/Inspection/GetInspection', options).pipe(catchError(this.handleError));
  }
  getInspectionPhoto(inspectionId): Observable<string> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<string>('api/Inspection/GetInspectionPhoto', options).pipe(catchError(this.handleError));
  }

  getInspectionDraft(equipmentId): Observable<CreateNewInspectionViewModel> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get<CreateNewInspectionViewModel>('api/Inspection/GetInspectionDraft', options).pipe(catchError(this.handleError));
  }

  refreshInspection(equipmentId, inspectionId): Observable<CreateNewInspectionViewModel> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('inspectionId', inspectionId.toString())
    };
    return this._http.get<CreateNewInspectionViewModel>('api/Inspection/RefreshInspection', options).pipe(catchError(this.handleError));
  }

  refreshInspectionDraft(equipmentId): Observable<CreateNewInspectionViewModel> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get<CreateNewInspectionViewModel>('api/Inspection/RefreshInspectionDraft', options).pipe(catchError(this.handleError));
  }

  getSystemView(equipmentId, inspectionId, side, systemType, newSmuReading, newPmuReading, totalInspDistance: number): Observable<SystemInspectionDetailView> {
    const options = {
      params: new HttpParams()
      .set('equipmentId', equipmentId.toString())
      .set('inspectionId', inspectionId.toString())
      .set('side', side.toString())
      .set('systemType', systemType.toString())
      .set('newSmuReading', newSmuReading.toString() )
      .set('newPmuReading', newPmuReading.toString() )
        .set('totalInspDistance', (totalInspDistance != undefined ? totalInspDistance.toString() : "0"))
    };
      return this._http.get<SystemInspectionDetailView>('api/Inspection/GetInspectionDraftSystems', options).pipe(catchError(this.handleError));
  }

  getInspectionSystems(equipmentId, inspectionId, side, systemType): Observable<SystemInspectionDetailView> {
    const options = {
      params: new HttpParams()
      .set('equipmentId', equipmentId.toString())
      .set('inspectionId', inspectionId.toString())
      .set('side', side.toString())
      .set('systemType', systemType.toString())
    };
    return this._http.get<SystemInspectionDetailView>('api/Inspection/GetInspectionSystems', options).pipe(catchError(this.handleError));
  }

  getWornPercentageOnComponent(query: WornPercentageCalculateViewModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/Inspection/GetWornPercentage', query).pipe(catchError(this.handleError));
  }

  saveInspectiondraftGeneralInfomation(model: CreateNewInspectionViewModel): Observable<CreateNewInspectionViewModel> {
    return this._http.post<CreateNewInspectionViewModel>('api/Inspection/SaveInspectionDraftGeneralInfomation', model).pipe(catchError(this.handleError));
  }

  saveAndInterpreteInspection(equipmentId: number): Observable<Tuple3> {
    const options = {
      params: new HttpParams()
      .set('equipmentId', equipmentId.toString())
    };
    return this._http.get<Tuple3>('api/Inspection/PublishInspection', options).pipe(catchError(this.handleError));
  }

  updateInspection(equipmentId, oldInspectionId: number): Observable<Tuple3> {
    const options = {
      params: new HttpParams()
      .set('equipmentId', equipmentId.toString())
      .set('oldInspectionId', oldInspectionId.toString())
    };
    return this._http.get<Tuple3>('api/Inspection/UpdateOldInspection', options).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.log(error);
    return Observable.throw(error.message || 'Server error');
  }

  postInspectionDraftImages(model: AddComponentPhotoModel) {
    return this._http.post('api/Inspection/AddComponentPhoto', model).pipe(catchError(this.handleError));
  }

  saveInspectionComponentDetailDraft(model: ComponentOnSystemInspectionViewModel, isCreatingNew: boolean) {
      return this._http.post('api/Inspection/SaveInspectionComponentDetailDraft', model).pipe(catchError(this.handleError));
  }

  public GetComponentMeasurementInspectionDraft(InspectionDetailId: number,equipmentId:number): Observable<ComponentOnSystemInspectionViewModel> {
    const options = {
      params: new HttpParams().set('InspectionDetailId', InspectionDetailId.toString()).set('equipmentId', equipmentId.toString())
    };
    return this._http.get<ComponentOnSystemInspectionViewModel>('api/Inspection/GetComponentMeasurementInspectionDraft', options).pipe(catchError(this.handleError));
  }
  
  public GetComponentComment( inspectionDetailId: number, equipmentId:number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('inspectionDetailId', inspectionDetailId.toString()).set('equipmentId', equipmentId.toString())
    };
    return this._http.get<Tuple>('api/Inspection/GetComponentComment', options).pipe(catchError(this.handleError));
  }

  saveCommentOnComponentDetail(detailId, equipmentId, comment): Observable<Tuple> {
    const options = {
      params: new HttpParams()
      .set('inspectionDetailDraftId', detailId.toString())
      .set('comment', comment.toString())
      .set('equipmentId', equipmentId.toString())
    };
    return this._http.get<Tuple>('api/Inspection/SaveComponentCommentOnInspectionDraft', options).pipe(catchError(this.handleError));
  }

  public GetComponentTypeComments(compartTypeId:number): Observable<GenericIdName[]> {
    const options = {
      params: new HttpParams().set('compartTypeId', compartTypeId.toString())
    };
    return this._http.get<GenericIdName[]>('api/Inspection/GetComponentTypeComments', options).pipe(catchError(this.handleError));
  }
  addObservationListOnTheFly(inspectionDraftId: number, title: string) {
    const options = {
      params: new HttpParams()
      .set('inspectionDraftId', inspectionDraftId.toString())
      .set('title', title.toString())
    };
    return this._http.get('api/Inspection/SaveNewAdditionalObservationListDraftOnTheFly', options).pipe(catchError(this.handleError));
  }

  addObservationListOnInterpretation(inspectionId: number, title: string) {
    const options = {
      params: new HttpParams()
      .set('inspectionId', inspectionId.toString())
      .set('title', title.toString())
    };
    return this._http.get('api/Inspection/SaveNewAdditionalObservationListOnInterpretation', options).pipe(catchError(this.handleError));
  }

  saveNewCustomerLevelAdditionalObservationList(model: AdditionalObservationListViewModel): Observable<Tuple>  {
    return this._http.post<Tuple>('api/Inspection/SaveNewCustomerLevelAdditionalObservationList', model).pipe(catchError(this.handleError));
  }
  saveNewModelLevelAdditionalObservationList(model: AdditionalObservationListViewModel): Observable<Tuple>  {
    return this._http.post<Tuple>('api/Inspection/SaveNewModelLevelAdditionalObservationList', model).pipe(catchError(this.handleError));
  }
  saveNewFamilyLevelAdditionalObservationList(model: AdditionalObservationListViewModel): Observable<Tuple>  {
    return this._http.post<Tuple>('api/Inspection/SaveNewFamilyLevelAdditionalObservationList', model).pipe(catchError(this.handleError));
  }

  UpdateAdditonalObsNumbericalLimits(model: AdditonalObsNumaricalLimits): Observable<any>  {
    return this._http.post('api/Inspection/UpdateAdditonalObsNumbericalLimits', model).pipe(catchError(this.handleError));
  }
  
  getCustomerLevelAdditionalObservationList(customerId: number): Observable<AdditionalObservationListViewModel[]>  {
    const options = {
      params: new HttpParams()
      .set('customerId', customerId.toString())
    };
    return this._http.get<AdditionalObservationListViewModel[]>('api/Inspection/GetCustomerLevelAdditionalObservationList', options).pipe(catchError(this.handleError));
  }
  getModelLevelAdditionalObservationList(modelId: number): Observable<AdditionalObservationListViewModel[]>  {
    const options = {
      params: new HttpParams()
      .set('modelId', modelId.toString())
    };
    return this._http.get<AdditionalObservationListViewModel[]>('api/Inspection/GetModelLevelAdditionalObservationList', options).pipe(catchError(this.handleError));
  }
  getFamilyLevelAdditionalObservationList(familyId: number): Observable<AdditionalObservationListViewModel[]>  {
    const options = {
      params: new HttpParams()
      .set('familyId', familyId.toString())
    };
    return this._http.get<AdditionalObservationListViewModel[]>('api/Inspection/GetFamilyLevelAdditionalObservationList', options).pipe(catchError(this.handleError));
  }
  getAdditionalObservationInfo(additionalObservationId: number): Observable<AdditionalObservationListViewModel> {
    const options = {
      params: new HttpParams()
        .set('AdditionalObservationId', additionalObservationId.toString())
    };
    return this._http.get<AdditionalObservationListViewModel>('api/Inspection/GetAdditionalObservationInfo', options).pipe(catchError(this.handleError));
  }
  GetAnswerListForAdditonalObservationId(AdditonalObsId: number): Observable<AnswerListVM[]>  {
    const options = {
      params: new HttpParams()
      .set('AdditonalObsId', AdditonalObsId.toString())
    };
    return this._http.get<AnswerListVM[]>('api/Inspection/GetAnswerListForAdditionalObservation', options).pipe(catchError(this.handleError));
  }

  updateObservationListProperties(model: AdditionalObservationListViewModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/Inspection/UpdateAdditionalObservationList', model).pipe(catchError(this.handleError));
  }

  getInspectionDraftObservationLists(inspectionDraftId: number): Observable<InspectionAdditionalObservationListsViewModel[]> {
    const options = {
      params: new HttpParams()
      .set('inspectionDraftId', inspectionDraftId.toString())
    };
    return this._http.get<InspectionAdditionalObservationListsViewModel[]>('api/Inspection/GetInspectionDraftObservationLists', options).pipe(catchError(this.handleError));
  }

  getInspectionDraftObservationListsComment(obDraftId: number): Observable<any> {
    const options = {
      params: new HttpParams()
      .set('obDraftId', obDraftId.toString())
    };
    return this._http.get('api/Inspection/GetObservationListDraftComment', options).pipe(catchError(this.handleError));
  }

  DeleteInspectionDraftObservationLists(obDraftId: number): Observable<any> {
    const options = {
      params: new HttpParams()
      .set('obDraftId', obDraftId.toString())
    };
    return this._http.get('api/Inspection/DeleteObservationListDraft', options).pipe(catchError(this.handleError));
  }
  
  getInspectionDraftObservationPhotoList(obDraftId: number): Observable<InspectionAdditionalObservationImagesVM[]> {
    const options = {
      params: new HttpParams()
      .set('obDraftId', obDraftId.toString())
    };
    return this._http.get<InspectionAdditionalObservationImagesVM[]>('api/Inspection/getInspectionDraftObservationPhotoList', options).pipe(catchError(this.handleError));
  }

  getAllRopeShovelModels(): Observable<ModelSelectionOptionViewModel[]> {
    return this._http.get<ModelSelectionOptionViewModel[]>('api/Inspection/GetRopeShovelModels').pipe(catchError(this.handleError));
  }

  getNewInspectionTypeTemplate(modelId) {
    const options = {
      params: new HttpParams().set('modelId', modelId.toString())
    };
    return this._http.get('api/Inspection/GetNewInspectionTypeTemplate', options).pipe(catchError(this.handleError));
  }

  getInspectionTypesByModelId(modelId) {
    const options = {
      params: new HttpParams().set('modelId', modelId.toString())
    };
    return this._http.get('api/Inspection/GetInspectionTypesByModelId', options).pipe(catchError(this.handleError));
  }

  getInspectionTypeByInspectionTypeId(inspectionTypeId): Observable<InspectionTypeConfigurationViewModel> {
    const options = {
      params: new HttpParams().set('inspectionTypeId', inspectionTypeId.toString())
    };
    return this._http.get<InspectionTypeConfigurationViewModel>('api/Inspection/GetInspectionTypeConfiguration', options).pipe(catchError(this.handleError));
  }

  saveInspectionTypeConfig(inspectionTypeConfig: InspectionTypeConfigurationViewModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/Inspection/SaveInspectionTypeConfig', inspectionTypeConfig).pipe(catchError(this.handleError));
  }

  getSystemViewSP(equipmentId, inspectionId, side, systemType, newSmuReading, newPmuReading, totalInspDistance: number): Observable<SystemInspectionDetailViewVM> {
    const options = {
      params: new HttpParams()
      .set('equipmentId', equipmentId.toString())
      .set('inspectionId', inspectionId.toString())
      .set('side', side.toString())
      .set('systemType', systemType.toString())
      .set('newSmuReading', newSmuReading.toString() )
      .set('newPmuReading', newPmuReading.toString() )
      .set('totalInspDistance', (totalInspDistance != undefined ? totalInspDistance.toString() : "0"))
    };
      return this._http.get<SystemInspectionDetailViewVM>('api/Inspection/GetSystemsDetailForAddEditInsp', options).pipe(catchError(this.handleError));
  }

  getSystemViewForEditSP(equipmentId, inspectionId, side, systemType, newSmuReading, newPmuReading, totalInspDistance: number): Observable<SystemInspectionDetailView> {
    const options = {
      params: new HttpParams()
      .set('equipmentId', equipmentId.toString())
      .set('inspectionId', inspectionId.toString())
      .set('side', side.toString())
      .set('systemType', systemType.toString())
      .set('newSmuReading', newSmuReading.toString() )
      .set('newPmuReading', newPmuReading.toString() )
        .set('totalInspDistance', (totalInspDistance != undefined ? totalInspDistance.toString() : "0"))
    };
      return this._http.get<SystemInspectionDetailView>('api/Inspection/GetInspectionDetailSystemsSP', options).pipe(catchError(this.handleError));
  }

  saveAndInterpreteInspectionSP(newInspection: CreateNewInspectionViewModel): Observable<Tuple3> {
    return this._http.post<Tuple3>('api/Inspection/PublishInspectionSP', newInspection).pipe(catchError(this.handleError));
  }

  updateInspectionSP(newInspection: CreateNewInspectionViewModel): Observable<Tuple3> {
    return this._http.post<Tuple3>('api/Inspection/UpdateOldInspectionSP', newInspection).pipe(catchError(this.handleError));
  }

  validateInspectionForPublish(validation: InspectionValidatorRequest): Observable<InspectionValidationViewVM> {
    return this._http.post<InspectionValidationViewVM>('api/Inspection/PublishInspectionValidationSP', validation).pipe(catchError(this.handleError));
  }
  saveDraft(inspection: CreateNewInspectionViewModel): Observable<any> {
    return this._http.post(`api/Inspection/SaveInspectionDraft`, 
      inspection
    ).pipe(catchError(this.handleError));
  }
}
